import { ADDBOOKING, DELETEBOOKING } from './actionTypes';

export const addbooking = (value) => {
  return {
    type: ADDBOOKING,
    payload: value,
  };
};

export const deletebooking = (value) => {
  return {
    type: DELETEBOOKING,
    payload: value,
  };
};
